export default {
  en: {
    title: 'Subscription',
    loadError: 'Failed to load',
    premium: 'Premium',
    price_month: '{{price}} per month',
    price_quarter: '{{price}} for 3 months',
    price_year: '{{price}} per year',
    chipActive: 'Active',
    chipEnding: 'Ending',
    chipInactive: 'Inactive',
    paidUntil: 'Paid until',
    endedOn: 'Ended on',
    autoRenew: 'Auto-renewal',
    on: 'On',
    off: 'Off',
    nextCharge: 'Next charge',
    nextChargeValue: '{{date}} · {{price}}',
    paymentMethod: 'Payment method',
    hintAutoRenew: 'Renews automatically on {{date}}. You can turn off auto-renewal at any time — Premium stays until the end of the paid period.',
    hintStars: 'Paid with Telegram Stars — Telegram renews it and you manage it in Telegram settings.',
    hintExpired: 'Premium has ended. Your progress is safe — everything will be there when you come back.',
    cancelAutoRenew: 'Turn off auto-renewal',
    resumeAutoRenew: 'Turn auto-renewal back on',
    renew: 'Renew',
    confirmCancelTitle: 'Turn off auto-renewal?',
    confirmCancelMessage: 'Premium stays until {{date}}.',
    confirmCancelButton: 'Turn off',
    noPremiumTitle: 'No Premium yet',
    noPremiumHint: 'Premium removes the limit on conversations with the tutor.',
    grantedHint: 'Granted without payment',
    paymentsTitle: 'Recent payments',
    showAll: 'Show all ({{count}})',
    showLess: 'Show less',
    status_pending: 'Processing',
    status_succeeded: 'Paid',
    status_canceled: 'Declined',
    status_canceledByUser: 'Canceled',
    status_refunded: 'Refunded',
    methodCard: 'Bank card',
    methodSbp: 'SBP',
    methodStars: 'Telegram Stars',
    methodUnknown: 'Payment',
    paymentTitle: 'Payment',
    paymentNotFound: 'Payment not found',
    detailStatus: 'Status',
    detailKind: 'Type',
    kindInitial: 'Payment',
    kindRenewal: 'Auto-renewal',
    detailTransactionId: 'Transaction ID',
    none: 'N/A',
    detailCreated: 'Created',
    detailPaid: 'Completed',
    detailRefunded: 'Refunded',
    detailPeriod: 'Period',
    detailInfo: 'Status details',
    infoPending: 'Your payment is being processed. This may take a few minutes.',
    checkingPayment: 'Checking your payment…',
    checkingShort: 'Checking…',
    paidBannerTitle: 'Payment received',
    paidBannerText: 'Premium is active until {{date}}.',
    payRequiredTitle: 'Payment required',
    payRequiredText: 'Your payment is ready. Tap the button below to complete it with {{method}}.',
    completePayment: 'Complete payment',
    payPageHint: 'The payment page may take a few seconds to load',
    cancelPaymentTitle: 'Cancel payment',
    cancelPaymentText: 'If you no longer want to continue with this payment, you can cancel it.',
    cancelPaymentButton: 'Cancel payment',
    infoCanceledByUser: 'This payment was canceled.',
    infoSucceeded: 'The payment went through.',
    infoPaid: 'The payment went through — Premium is paid until {{date}}.',
    infoRenewed: 'Auto-renewal went through — Premium is extended until {{date}}.',
    infoRefunded: 'The money was returned on {{date}}. Premium for this period is turned off.',
    infoRefundedNoDate: 'The money was returned. Premium for this period is turned off.',
    infoRefundedPartial: '{{amount}} of {{total}} was returned on {{date}}. Premium for this period is turned off.',
    infoCanceled: "The payment didn't go through: {{reason}}",
    infoRenewalFailed: "Auto-renewal didn't go through: {{reason}} Premium is paused — you can renew it manually.",
    reason_insufficient_funds: 'not enough money on the card.',
    reason_card_expired: 'the card has expired.',
    reason_expired_on_confirmation: 'the payment was not completed in time.',
    reason_3d_secure_failed: 'the bank confirmation was not passed.',
    reason_canceled_by_merchant: 'the payment was canceled.',
    reason_permission_revoked: 'permission for automatic charges was revoked.',
    reason_other: 'the bank declined the payment.',
  },
  ru: {
    title: 'Подписка',
    loadError: 'Не удалось загрузить',
    premium: 'Премиум',
    price_month: '{{price}} в месяц',
    price_quarter: '{{price}} за 3 месяца',
    price_year: '{{price}} в год',
    chipActive: 'Активна',
    chipEnding: 'Заканчивается',
    chipInactive: 'Не активна',
    paidUntil: 'Оплачено до',
    endedOn: 'Закончилась',
    autoRenew: 'Автопродление',
    on: 'Включено',
    off: 'Выключено',
    nextCharge: 'Следующее списание',
    nextChargeValue: '{{date}} · {{price}}',
    paymentMethod: 'Способ оплаты',
    hintAutoRenew: 'Продлится автоматически {{date}}. Отключить автопродление можно в любой момент — премиум останется до конца оплаченного срока.',
    hintStars: 'Оплачено звёздами Telegram — продлевает и отменяется подписка в настройках Telegram.',
    hintExpired: 'Премиум закончился. Прогресс на месте — всё сохранится, когда вернёшься.',
    cancelAutoRenew: 'Отключить автопродление',
    resumeAutoRenew: 'Включить автопродление',
    renew: 'Продлить',
    confirmCancelTitle: 'Отключить автопродление?',
    confirmCancelMessage: 'Премиум останется до {{date}}.',
    confirmCancelButton: 'Отключить',
    noPremiumTitle: 'Премиума пока нет',
    noPremiumHint: 'Премиум снимает ограничение на разговоры с репетитором.',
    grantedHint: 'Выдан без оплаты',
    paymentsTitle: 'Последние платежи',
    showAll: 'Показать все ({{count}})',
    showLess: 'Свернуть',
    status_pending: 'В обработке',
    status_succeeded: 'Оплачено',
    status_canceled: 'Отклонено',
    status_canceledByUser: 'Отменено',
    status_refunded: 'Возвращено',
    methodCard: 'Банковская карта',
    methodSbp: 'СБП',
    methodStars: 'Telegram Stars',
    methodUnknown: 'Платёж',
    paymentTitle: 'Платёж',
    paymentNotFound: 'Платёж не найден',
    detailStatus: 'Статус',
    detailKind: 'Тип',
    kindInitial: 'Оплата',
    kindRenewal: 'Автопродление',
    detailTransactionId: 'ID транзакции',
    none: 'Н/Д',
    detailCreated: 'Создан',
    detailPaid: 'Завершён',
    detailRefunded: 'Возвращён',
    detailPeriod: 'Период',
    detailInfo: 'Информация о статусе',
    infoPending: 'Ваш платёж обрабатывается. Это может занять несколько минут.',
    checkingPayment: 'Проверяем оплату…',
    checkingShort: 'Проверяем…',
    paidBannerTitle: 'Оплата прошла',
    paidBannerText: 'Премиум активен до {{date}}.',
    payRequiredTitle: 'Требуется оплата',
    payRequiredText: 'Платёж готов к оплате. Нажмите кнопку ниже, чтобы завершить оплату через {{method}}.',
    completePayment: 'Завершить оплату',
    payPageHint: 'Страница оплаты может загружаться несколько секунд',
    cancelPaymentTitle: 'Отменить пополнение',
    cancelPaymentText: 'Если вы больше не хотите продолжать это пополнение, вы можете отменить его.',
    cancelPaymentButton: 'Отменить пополнение',
    infoCanceledByUser: 'Этот платёж был отменён.',
    infoSucceeded: 'Платёж прошёл.',
    infoPaid: 'Платёж прошёл — премиум оплачен до {{date}}.',
    infoRenewed: 'Автопродление прошло — премиум продлён до {{date}}.',
    infoRefunded: 'Деньги возвращены {{date}}. Премиум за этот период отключён.',
    infoRefundedNoDate: 'Деньги возвращены. Премиум за этот период отключён.',
    infoRefundedPartial: 'Возвращено {{amount}} из {{total}} — {{date}}. Премиум за этот период отключён.',
    infoCanceled: 'Платёж не прошёл: {{reason}}',
    infoRenewalFailed: 'Автопродление не прошло: {{reason}} Премиум на паузе — продлить можно вручную.',
    reason_insufficient_funds: 'на карте недостаточно средств.',
    reason_card_expired: 'истёк срок действия карты.',
    reason_expired_on_confirmation: 'оплата не была завершена вовремя.',
    reason_3d_secure_failed: 'не пройдено подтверждение в банке.',
    reason_canceled_by_merchant: 'платёж отменён.',
    reason_permission_revoked: 'разрешение на автосписание отозвано.',
    reason_other: 'банк отклонил платёж.',
  },
  de: {
    title: 'Abo',
    loadError: 'Laden fehlgeschlagen',
    premium: 'Premium',
    price_month: '{{price}} pro Monat',
    price_quarter: '{{price}} für 3 Monate',
    price_year: '{{price}} pro Jahr',
    chipActive: 'Aktiv',
    chipEnding: 'Läuft aus',
    chipInactive: 'Inaktiv',
    paidUntil: 'Bezahlt bis',
    endedOn: 'Beendet am',
    autoRenew: 'Automatische Verlängerung',
    on: 'An',
    off: 'Aus',
    nextCharge: 'Nächste Abbuchung',
    nextChargeValue: '{{date}} · {{price}}',
    paymentMethod: 'Zahlungsmethode',
    hintAutoRenew: 'Verlängert sich automatisch am {{date}}. Du kannst die Verlängerung jederzeit ausschalten – Premium bleibt bis zum Ende des bezahlten Zeitraums.',
    hintStars: 'Mit Telegram Stars bezahlt – Telegram verlängert das Abo, verwaltet wird es in den Telegram-Einstellungen.',
    hintExpired: 'Premium ist abgelaufen. Dein Fortschritt bleibt erhalten.',
    cancelAutoRenew: 'Verlängerung ausschalten',
    resumeAutoRenew: 'Verlängerung wieder einschalten',
    renew: 'Verlängern',
    confirmCancelTitle: 'Verlängerung ausschalten?',
    confirmCancelMessage: 'Premium bleibt bis {{date}}.',
    confirmCancelButton: 'Ausschalten',
    noPremiumTitle: 'Noch kein Premium',
    noPremiumHint: 'Premium hebt die Begrenzung für Gespräche mit dem Tutor auf.',
    grantedHint: 'Ohne Zahlung freigeschaltet',
    paymentsTitle: 'Letzte Zahlungen',
    showAll: 'Alle anzeigen ({{count}})',
    showLess: 'Weniger anzeigen',
    status_pending: 'In Bearbeitung',
    status_succeeded: 'Bezahlt',
    status_canceled: 'Abgelehnt',
    status_canceledByUser: 'Abgebrochen',
    status_refunded: 'Erstattet',
    methodCard: 'Bankkarte',
    methodSbp: 'SBP',
    methodStars: 'Telegram Stars',
    methodUnknown: 'Zahlung',
    paymentTitle: 'Zahlung',
    paymentNotFound: 'Zahlung nicht gefunden',
    detailStatus: 'Status',
    detailKind: 'Art',
    kindInitial: 'Zahlung',
    kindRenewal: 'Automatische Verlängerung',
    detailTransactionId: 'Transaktions-ID',
    none: 'k. A.',
    detailCreated: 'Erstellt',
    detailPaid: 'Abgeschlossen',
    detailRefunded: 'Erstattet',
    detailPeriod: 'Zeitraum',
    detailInfo: 'Statusinformation',
    infoPending: 'Deine Zahlung wird bearbeitet. Das kann ein paar Minuten dauern.',
    checkingPayment: 'Wir prüfen deine Zahlung…',
    checkingShort: 'Prüfen…',
    paidBannerTitle: 'Zahlung eingegangen',
    paidBannerText: 'Premium ist aktiv bis {{date}}.',
    payRequiredTitle: 'Zahlung erforderlich',
    payRequiredText: 'Deine Zahlung ist bereit. Tippe unten, um sie mit {{method}} abzuschließen.',
    completePayment: 'Zahlung abschließen',
    payPageHint: 'Die Zahlungsseite kann ein paar Sekunden zum Laden brauchen',
    cancelPaymentTitle: 'Zahlung abbrechen',
    cancelPaymentText: 'Wenn du diese Zahlung nicht mehr fortsetzen möchtest, kannst du sie abbrechen.',
    cancelPaymentButton: 'Zahlung abbrechen',
    infoCanceledByUser: 'Diese Zahlung wurde abgebrochen.',
    infoSucceeded: 'Die Zahlung ist eingegangen.',
    infoPaid: 'Die Zahlung ist eingegangen – Premium ist bis {{date}} bezahlt.',
    infoRenewed: 'Die Verlängerung hat geklappt – Premium läuft bis {{date}}.',
    infoRefunded: 'Das Geld wurde am {{date}} erstattet. Premium für diesen Zeitraum ist aus.',
    infoRefundedNoDate: 'Das Geld wurde erstattet. Premium für diesen Zeitraum ist aus.',
    infoRefundedPartial: 'Am {{date}} wurden {{amount}} von {{total}} erstattet. Premium für diesen Zeitraum ist aus.',
    infoCanceled: 'Die Zahlung ist fehlgeschlagen: {{reason}}',
    infoRenewalFailed: 'Die Verlängerung ist fehlgeschlagen: {{reason}} Premium ist pausiert – du kannst es manuell verlängern.',
    reason_insufficient_funds: 'nicht genug Guthaben auf der Karte.',
    reason_card_expired: 'die Karte ist abgelaufen.',
    reason_expired_on_confirmation: 'die Zahlung wurde nicht rechtzeitig abgeschlossen.',
    reason_3d_secure_failed: 'die Bestätigung bei der Bank ist fehlgeschlagen.',
    reason_canceled_by_merchant: 'die Zahlung wurde storniert.',
    reason_permission_revoked: 'die Erlaubnis für automatische Abbuchungen wurde widerrufen.',
    reason_other: 'die Bank hat die Zahlung abgelehnt.',
  },
  pt: {
    title: 'Assinatura',
    loadError: 'Falha ao carregar',
    premium: 'Premium',
    price_month: '{{price}} por mês',
    price_quarter: '{{price}} por 3 meses',
    price_year: '{{price}} por ano',
    chipActive: 'Ativa',
    chipEnding: 'Terminando',
    chipInactive: 'Inativa',
    paidUntil: 'Pago até',
    endedOn: 'Terminou em',
    autoRenew: 'Renovação automática',
    on: 'Ativada',
    off: 'Desativada',
    nextCharge: 'Próxima cobrança',
    nextChargeValue: '{{date}} · {{price}}',
    paymentMethod: 'Forma de pagamento',
    hintAutoRenew: 'Renova automaticamente em {{date}}. Você pode desativar a renovação a qualquer momento — o Premium continua até o fim do período pago.',
    hintStars: 'Pago com Telegram Stars — o Telegram renova a assinatura, e ela é gerenciada nas configurações do Telegram.',
    hintExpired: 'O Premium terminou. Seu progresso continua salvo.',
    cancelAutoRenew: 'Desativar renovação automática',
    resumeAutoRenew: 'Reativar renovação automática',
    renew: 'Renovar',
    confirmCancelTitle: 'Desativar a renovação automática?',
    confirmCancelMessage: 'O Premium continua até {{date}}.',
    confirmCancelButton: 'Desativar',
    noPremiumTitle: 'Ainda sem Premium',
    noPremiumHint: 'O Premium remove o limite de conversas com o tutor.',
    grantedHint: 'Concedido sem pagamento',
    paymentsTitle: 'Pagamentos recentes',
    showAll: 'Mostrar todos ({{count}})',
    showLess: 'Mostrar menos',
    status_pending: 'Processando',
    status_succeeded: 'Pago',
    status_canceled: 'Recusado',
    status_canceledByUser: 'Cancelado',
    status_refunded: 'Reembolsado',
    methodCard: 'Cartão bancário',
    methodSbp: 'SBP',
    methodStars: 'Telegram Stars',
    methodUnknown: 'Pagamento',
    paymentTitle: 'Pagamento',
    paymentNotFound: 'Pagamento não encontrado',
    detailStatus: 'Status',
    detailKind: 'Tipo',
    kindInitial: 'Pagamento',
    kindRenewal: 'Renovação automática',
    detailTransactionId: 'ID da transação',
    none: 'N/D',
    detailCreated: 'Criado',
    detailPaid: 'Concluído',
    detailRefunded: 'Reembolsado',
    detailPeriod: 'Período',
    detailInfo: 'Informação do status',
    infoPending: 'Seu pagamento está sendo processado. Isso pode levar alguns minutos.',
    checkingPayment: 'Verificando o pagamento…',
    checkingShort: 'Verificando…',
    paidBannerTitle: 'Pagamento recebido',
    paidBannerText: 'O Premium está ativo até {{date}}.',
    payRequiredTitle: 'Pagamento pendente',
    payRequiredText: 'Seu pagamento está pronto. Toque no botão abaixo para concluí-lo com {{method}}.',
    completePayment: 'Concluir pagamento',
    payPageHint: 'A página de pagamento pode levar alguns segundos para carregar',
    cancelPaymentTitle: 'Cancelar pagamento',
    cancelPaymentText: 'Se você não quer mais continuar com este pagamento, pode cancelá-lo.',
    cancelPaymentButton: 'Cancelar pagamento',
    infoCanceledByUser: 'Este pagamento foi cancelado.',
    infoSucceeded: 'O pagamento foi aprovado.',
    infoPaid: 'O pagamento foi aprovado — o Premium está pago até {{date}}.',
    infoRenewed: 'A renovação foi aprovada — o Premium vai até {{date}}.',
    infoRefunded: 'O dinheiro foi devolvido em {{date}}. O Premium deste período foi desativado.',
    infoRefundedNoDate: 'O dinheiro foi devolvido. O Premium deste período foi desativado.',
    infoRefundedPartial: 'Foram devolvidos {{amount}} de {{total}} em {{date}}. O Premium deste período foi desativado.',
    infoCanceled: 'O pagamento não foi aprovado: {{reason}}',
    infoRenewalFailed: 'A renovação não foi aprovada: {{reason}} O Premium está pausado — você pode renová-lo manualmente.',
    reason_insufficient_funds: 'saldo insuficiente no cartão.',
    reason_card_expired: 'o cartão expirou.',
    reason_expired_on_confirmation: 'o pagamento não foi concluído a tempo.',
    reason_3d_secure_failed: 'a confirmação do banco não foi concluída.',
    reason_canceled_by_merchant: 'o pagamento foi cancelado.',
    reason_permission_revoked: 'a permissão para cobranças automáticas foi revogada.',
    reason_other: 'o banco recusou o pagamento.',
  },
  fr: {
    title: 'Abonnement',
    loadError: 'Échec du chargement',
    premium: 'Premium',
    price_month: '{{price}} par mois',
    price_quarter: '{{price}} pour 3 mois',
    price_year: '{{price}} par an',
    chipActive: 'Actif',
    chipEnding: 'Se termine',
    chipInactive: 'Inactif',
    paidUntil: 'Payé jusqu’au',
    endedOn: 'Terminé le',
    autoRenew: 'Renouvellement automatique',
    on: 'Activé',
    off: 'Désactivé',
    nextCharge: 'Prochain prélèvement',
    nextChargeValue: '{{date}} · {{price}}',
    paymentMethod: 'Moyen de paiement',
    hintAutoRenew: 'Se renouvelle automatiquement le {{date}}. Vous pouvez désactiver le renouvellement à tout moment — Premium reste actif jusqu’à la fin de la période payée.',
    hintStars: 'Payé avec des Telegram Stars — Telegram renouvelle l’abonnement, qui se gère dans les réglages de Telegram.',
    hintExpired: 'Premium est terminé. Votre progression est conservée.',
    cancelAutoRenew: 'Désactiver le renouvellement',
    resumeAutoRenew: 'Réactiver le renouvellement',
    renew: 'Renouveler',
    confirmCancelTitle: 'Désactiver le renouvellement ?',
    confirmCancelMessage: 'Premium reste actif jusqu’au {{date}}.',
    confirmCancelButton: 'Désactiver',
    noPremiumTitle: 'Pas encore de Premium',
    noPremiumHint: 'Premium supprime la limite de conversations avec le tuteur.',
    grantedHint: 'Accordé sans paiement',
    paymentsTitle: 'Paiements récents',
    showAll: 'Tout afficher ({{count}})',
    showLess: 'Réduire',
    status_pending: 'En cours',
    status_succeeded: 'Payé',
    status_canceled: 'Refusé',
    status_canceledByUser: 'Annulé',
    status_refunded: 'Remboursé',
    methodCard: 'Carte bancaire',
    methodSbp: 'SBP',
    methodStars: 'Telegram Stars',
    methodUnknown: 'Paiement',
    paymentTitle: 'Paiement',
    paymentNotFound: 'Paiement introuvable',
    detailStatus: 'Statut',
    detailKind: 'Type',
    kindInitial: 'Paiement',
    kindRenewal: 'Renouvellement automatique',
    detailTransactionId: 'ID de transaction',
    none: 'N/A',
    detailCreated: 'Créé',
    detailPaid: 'Terminé',
    detailRefunded: 'Remboursé',
    detailPeriod: 'Période',
    detailInfo: 'Informations sur le statut',
    infoPending: 'Votre paiement est en cours de traitement. Cela peut prendre quelques minutes.',
    checkingPayment: 'Vérification du paiement…',
    checkingShort: 'Vérification…',
    paidBannerTitle: 'Paiement reçu',
    paidBannerText: 'Premium est actif jusqu’au {{date}}.',
    payRequiredTitle: 'Paiement requis',
    payRequiredText: 'Votre paiement est prêt. Appuyez sur le bouton ci-dessous pour le finaliser avec {{method}}.',
    completePayment: 'Finaliser le paiement',
    payPageHint: 'La page de paiement peut mettre quelques secondes à se charger',
    cancelPaymentTitle: 'Annuler le paiement',
    cancelPaymentText: 'Si vous ne souhaitez plus poursuivre ce paiement, vous pouvez l’annuler.',
    cancelPaymentButton: 'Annuler le paiement',
    infoCanceledByUser: 'Ce paiement a été annulé.',
    infoSucceeded: 'Le paiement a été accepté.',
    infoPaid: 'Le paiement a été accepté — Premium est payé jusqu’au {{date}}.',
    infoRenewed: 'Le renouvellement a été accepté — Premium est prolongé jusqu’au {{date}}.',
    infoRefunded: 'L’argent a été remboursé le {{date}}. Premium pour cette période est désactivé.',
    infoRefundedNoDate: 'L’argent a été remboursé. Premium pour cette période est désactivé.',
    infoRefundedPartial: '{{amount}} sur {{total}} ont été remboursés le {{date}}. Premium pour cette période est désactivé.',
    infoCanceled: 'Le paiement a échoué : {{reason}}',
    infoRenewalFailed: 'Le renouvellement a échoué : {{reason}} Premium est en pause — vous pouvez le renouveler manuellement.',
    reason_insufficient_funds: 'solde insuffisant sur la carte.',
    reason_card_expired: 'la carte a expiré.',
    reason_expired_on_confirmation: 'le paiement n’a pas été finalisé à temps.',
    reason_3d_secure_failed: 'la confirmation auprès de la banque a échoué.',
    reason_canceled_by_merchant: 'le paiement a été annulé.',
    reason_permission_revoked: 'l’autorisation de prélèvement automatique a été révoquée.',
    reason_other: 'la banque a refusé le paiement.',
  },
  es: {
    title: 'Suscripción',
    loadError: 'No se pudo cargar',
    premium: 'Premium',
    price_month: '{{price}} al mes',
    price_quarter: '{{price}} por 3 meses',
    price_year: '{{price}} al año',
    chipActive: 'Activa',
    chipEnding: 'Termina pronto',
    chipInactive: 'Inactiva',
    paidUntil: 'Pagado hasta',
    endedOn: 'Terminó el',
    autoRenew: 'Renovación automática',
    on: 'Activada',
    off: 'Desactivada',
    nextCharge: 'Próximo cobro',
    nextChargeValue: '{{date}} · {{price}}',
    paymentMethod: 'Método de pago',
    hintAutoRenew: 'Se renueva automáticamente el {{date}}. Puedes desactivar la renovación en cualquier momento: Premium sigue hasta el final del periodo pagado.',
    hintStars: 'Pagado con Telegram Stars: Telegram renueva la suscripción y se gestiona en los ajustes de Telegram.',
    hintExpired: 'Premium ha terminado. Tu progreso sigue guardado.',
    cancelAutoRenew: 'Desactivar renovación automática',
    resumeAutoRenew: 'Reactivar renovación automática',
    renew: 'Renovar',
    confirmCancelTitle: '¿Desactivar la renovación automática?',
    confirmCancelMessage: 'Premium sigue hasta el {{date}}.',
    confirmCancelButton: 'Desactivar',
    noPremiumTitle: 'Aún sin Premium',
    noPremiumHint: 'Premium elimina el límite de conversaciones con el tutor.',
    grantedHint: 'Concedido sin pago',
    paymentsTitle: 'Pagos recientes',
    showAll: 'Mostrar todos ({{count}})',
    showLess: 'Mostrar menos',
    status_pending: 'En proceso',
    status_succeeded: 'Pagado',
    status_canceled: 'Rechazado',
    status_canceledByUser: 'Cancelado',
    status_refunded: 'Reembolsado',
    methodCard: 'Tarjeta bancaria',
    methodSbp: 'SBP',
    methodStars: 'Telegram Stars',
    methodUnknown: 'Pago',
    paymentTitle: 'Pago',
    paymentNotFound: 'Pago no encontrado',
    detailStatus: 'Estado',
    detailKind: 'Tipo',
    kindInitial: 'Pago',
    kindRenewal: 'Renovación automática',
    detailTransactionId: 'ID de transacción',
    none: 'N/D',
    detailCreated: 'Creado',
    detailPaid: 'Completado',
    detailRefunded: 'Reembolsado',
    detailPeriod: 'Periodo',
    detailInfo: 'Información del estado',
    infoPending: 'Tu pago se está procesando. Puede tardar unos minutos.',
    checkingPayment: 'Comprobando el pago…',
    checkingShort: 'Comprobando…',
    paidBannerTitle: 'Pago recibido',
    paidBannerText: 'Premium está activo hasta el {{date}}.',
    payRequiredTitle: 'Pago pendiente',
    payRequiredText: 'Tu pago está listo. Pulsa el botón de abajo para completarlo con {{method}}.',
    completePayment: 'Completar pago',
    payPageHint: 'La página de pago puede tardar unos segundos en cargar',
    cancelPaymentTitle: 'Cancelar pago',
    cancelPaymentText: 'Si ya no quieres continuar con este pago, puedes cancelarlo.',
    cancelPaymentButton: 'Cancelar pago',
    infoCanceledByUser: 'Este pago fue cancelado.',
    infoSucceeded: 'El pago se ha completado.',
    infoPaid: 'El pago se ha completado: Premium está pagado hasta el {{date}}.',
    infoRenewed: 'La renovación se ha completado: Premium se extiende hasta el {{date}}.',
    infoRefunded: 'El dinero se devolvió el {{date}}. Premium de este periodo está desactivado.',
    infoRefundedNoDate: 'El dinero se devolvió. Premium de este periodo está desactivado.',
    infoRefundedPartial: 'Se devolvieron {{amount}} de {{total}} el {{date}}. Premium de este periodo está desactivado.',
    infoCanceled: 'El pago no se completó: {{reason}}',
    infoRenewalFailed: 'La renovación no se completó: {{reason}} Premium está en pausa; puedes renovarlo manualmente.',
    reason_insufficient_funds: 'saldo insuficiente en la tarjeta.',
    reason_card_expired: 'la tarjeta ha caducado.',
    reason_expired_on_confirmation: 'el pago no se completó a tiempo.',
    reason_3d_secure_failed: 'no se superó la confirmación del banco.',
    reason_canceled_by_merchant: 'el pago se canceló.',
    reason_permission_revoked: 'se revocó el permiso para cobros automáticos.',
    reason_other: 'el banco rechazó el pago.',
  },
};
